import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import { Grid, Image, Loader } from 'semantic-ui-react';

import snukLogin from '../../assets/snukLogin.png';
import auth from '../../utils/auth';

class Logout extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: true,
    };
  }

  componentDidMount() {
    auth.logout();
    this.setState({ isLoggedIn: false });
  }

  render() {
    const { t } = this.props;

    return (
      <div>
        {this.state.isLoggedIn
          ? (
            <div className="loader-container">
              <Loader active size="large" />
            </div>
          )
          : (
            <Grid style={{ paddingTop: '10vh' }}>
              <Grid.Row>
                <Grid.Column width="6" />
                <Grid.Column width="4">
                  <Image src={snukLogin} size="small" centered />
                </Grid.Column>
                <Grid.Column width="6" />
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width="6" />
                <Grid.Column width="4" textAlign="center">
                  <p style={{ fontSize: '17px' }}>{t('usersConfig.logged-out')}.</p>
                  <Link to="/login">{t('usersConfig.login-again')}</Link>
                </Grid.Column>
                <Grid.Column width="6" />
              </Grid.Row>
            </Grid>
          )
        }
      </div>
    );
  }
}

export default translate()(Logout);



// WEBPACK FOOTER //
// ./src/components/Logout/Logout.js